import { useEffect } from "react";

interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
  type?: string;
  jsonLd?: object | object[];
}

function setMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, keywords, type = "website", jsonLd }: SeoProps) {
  useEffect(() => {
    document.title = title;
    const canonical = window.location.origin + window.location.pathname;

    setMeta("name", "description", description);
    if (keywords) setMeta("name", "keywords", keywords);
    setMeta("name", "robots", "index,follow");
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", type);
    setMeta("property", "og:url", canonical);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);

    let link = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.setAttribute("rel", "canonical");
      document.head.appendChild(link);
    }
    link.setAttribute("href", canonical);

    const block = document.createElement("script");
    block.type = "application/ld+json";
    block.setAttribute("data-seo-jsonld", "true");
    block.textContent = JSON.stringify(jsonLd || { "@context": "https://schema.org", "@type": "WebPage", name: title });
    document.head.appendChild(block);
    return () => {
      document.head.querySelectorAll('script[data-seo-jsonld="true"]').forEach((n) => n.remove());
    };
  }, [title, description, keywords, type, jsonLd]);

  return null;
}